module.exports = __webpack_public_path__ + "media/icons/key-3-44f0491a.svg";